import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectMetadataKeyByRegion } from 'reducers/selectors/metadata';
import { ALERT_SHOW } from '../../actions/alert/constants';

import './alert.scss';

const Alert = () => {
  const dispatch = useDispatch();
  const show = useSelector(state => state.Player.Alert.show);
  const message = useSelector(state => state.Player.Alert.message);
  const alertTime = useSelector(
    selectMetadataKeyByRegion('alert_autoHideTime'),
  );
  const alertRef = useRef(null);

  useEffect(
    () => {
      if (show) {
        const time = alertTime?.time || 3;

        const timer = setTimeout(() => {
          dispatch({
            type: ALERT_SHOW,
            payload: false,
          });
        }, time * 1000);

        return () => {
          clearTimeout(timer);
          dispatch({
            type: ALERT_SHOW,
            payload: false,
          });
        };
      }
    },
    [show],
  );

  if (!show) return false;
  return (
    <div className="alertPop" ref={alertRef}>
      <div className="alertPop--container">
        <div className="alertPop--message">{message}</div>
      </div>
    </div>
  );
};

export default Alert;
